import { Tween } from 'react-gsap';
import Section from '../Section.jsx';
import styles from './SectionIntro.module.scss';

function SectionIntro() {
  return (
    <Section scrub className={ styles.section }>
      <div className={ styles.container }>
        {/* <img src={ `${process.env.PUBLIC_URL}/images/02/an-open-dialogue-with.png` } className={ styles.title1 } /> */}
        <Tween from={{ opacity: 0, scale: 1.5 }} to={{ opacity: 1, scale: 1 }}>
          <img src={ `${process.env.PUBLIC_URL}/images/02/jackson-wang.png` } className={ styles.title2 } />
        </Tween>
        <br />
        <img src={ `${process.env.PUBLIC_URL}/images/02/unmasked.png` } className={ styles.title4 } />
        <br />
        <img src={ `${process.env.PUBLIC_URL}/images/02/title3.png` } className={ styles.title3 } />

        <Tween from={{ y: '-20%', opacity: 0 }} to={{ y: '0%', opacity: 1 }}>
          <p className={ styles.text }>
            每個人在社會上生存或多或少都會戴上一副面具，展示自己理想的一面，又或是作為免受傷害的第一道屏障；而一位耀眼的巨星，在國際演藝舞台的聚光燈下，願意放下他以往的一些身分，你願意了解他背後真實的一面嗎？
            <br /><br />
          </p>
          <div className={ styles.credit }>
            Words by Oscar Law<br />
            Photography by Matt Cowen
          </div>
        </Tween>
      </div>
    </Section>
  );
}

export default SectionIntro;
